var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { getMonth } from '../../utils/date-object.utils';
import { ChartGrid } from './chart-grid';
var ChartGridMonth = /** @class */ (function (_super) {
    __extends(ChartGridMonth, _super);
    function ChartGridMonth(ctrlr) {
        return _super.call(this, ctrlr) || this;
    }
    ChartGridMonth.prototype.redraw = function (data, colour) {
        var self = this;
        _super.prototype.redraw.call(this, data, colour);
        this.ctrlr.svg.gridNumbers
            .text(function (d, i) {
            var date = new Date(d[self.ctrlr.parameters.x]);
            // we rapporteren over de month ervoor
            date.setDate(date.getDate() - 7);
            if (i === data.length - 1) {
                return '';
            }
            else {
                return getMonth(date);
            }
        });
    };
    return ChartGridMonth;
}(ChartGrid));
export { ChartGridMonth };
